var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.109,
    height: 18.109,
    viewBox: "0 0 18.109 18.109",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "question-circle",
    d: "M26.109,17.055A9.055,9.055,0,1,1,17.055,8,9.054,9.054,0,0,1,26.109,17.055ZM17.3,10.994a4.729,4.729,0,0,0-4.255,2.328.439.439,0,0,0,.1.594l1.267.961a.438.438,0,0,0,.608-.077c.652-.827,1.1-1.307,2.092-1.307.746,0,1.668.48,1.668,1.2,0,.547-.451.828-1.188,1.24-.859.481-2,1.081-2,2.58v.146a.438.438,0,0,0,.438.438h2.045a.438.438,0,0,0,.438-.438v-.049c0-1.039,3.037-1.082,3.037-3.895C21.552,12.6,19.356,10.994,17.3,10.994Zm-.243,9.055a1.679,1.679,0,1,0,1.679,1.679A1.681,1.681,0,0,0,17.055,20.049Z",
    transform: "translate(-8 -8)",
    fill: "#0076ce"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionCircle);
export default __webpack_public_path__ + "static/media/question-circle.a9f65a8d6b0e57510c9ea7d3a1f7e452.svg";
export { ForwardRef as ReactComponent };